/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum UserAccessType {
    Permission = 'Permission',
    Role = 'Role'
}


export function instanceOfUserAccessType(value: any): boolean {
    for (const key in UserAccessType) {
        if (Object.prototype.hasOwnProperty.call(UserAccessType, key)) {
            if (UserAccessType[key as keyof typeof UserAccessType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserAccessTypeFromJSON(json: any): UserAccessType {
    return UserAccessTypeFromJSONTyped(json, false);
}

export function UserAccessTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAccessType {
    return json as UserAccessType;
}

export function UserAccessTypeToJSON(value?: UserAccessType | null): any {
    return value as any;
}

export function UserAccessTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): UserAccessType {
    return value as UserAccessType;
}

